module.exports = __webpack_public_path__ + "img/js.654a068f.svg";